.card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: var(--shadow-close);
  margin-bottom: 24px;
  min-width: 0;
  padding: 20px 24px;
}

.dark {
  background: linear-gradient(160deg, var(--color-primary-light), var(--color-primary-deep));
  color: var(--color-text-on-primary);
}

.heading {
  font-family: var(--font-family-heading);
  font-size: 1.5rem;
  margin: 0 0 12px;
}

.text {
  font-size: var(--font-size-small);
  margin: 0 0 12px;
}

.coaches {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.coaches img {
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  object-fit: cover;
}

.coachComment {
  border-left: 3px solid var(--color-accent);
  font-size: var(--font-size-small);
  margin: 0 0 16px;
  padding-left: 12px;
}

.coachComment p {
  margin: 0 0 4px;
  white-space: pre-line;
}

.coachComment footer,
.quote footer {
  font-size: var(--font-size-small);
  opacity: 0.8;
}

.coachComment footer {
  align-items: center;
  display: flex;
  gap: 6px;
}

.coachPortrait {
  border-radius: 50%;
  object-fit: cover;
}

.tag {
  background: var(--color-tertiary-background);
  border-radius: 999px;
  display: inline-block;
  font-size: var(--font-size-small);
  margin: 0 0 12px;
  padding: 2px 12px;
}

.quote {
  font-family: var(--font-family-heading);
  font-size: 1.125rem;
  margin: 0 0 8px;
  overflow-wrap: anywhere;
}

.quote p {
  margin: 0 0 8px;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.button {
  background: transparent;
  border: 1px solid var(--color-primary);
  border-radius: 999px;
  color: var(--color-primary);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-small);
  padding: 8px 16px;
  text-decoration: none;
}

.button:hover {
  background: var(--color-tertiary-background);
}

.button:focus-visible {
  outline: 3px solid var(--color-info-border);
  outline-offset: 2px;
}
